import { Loadable } from './loadable';

/**
 * Factory methods for quickly creating common types of Loadable states
 **/
export namespace LoadableFactory {
  /**
   * Create a Loadable mask without loading state or data
   *
   * @return {Loadable<T>} A Loadable representing the reset state.
   */
  export function reset<T>(): Loadable<T> {
    return {
      data: undefined,
      isLoading: undefined,
      loadingError: undefined,
    };
  }

  /**
   * Create a Loadable that contains data, without error or loading state.
   *
   * @param {T} data - the data that has been loaded
   * @returns {Loadable<T>} A Loadable representing loaded data.
   **/
  export function loaded<T>(data: T): Loadable<T> {
    return {
      data,
      isLoading: undefined,
      loadingError: undefined,
    };
  }

  /**
   * Create a Loadable representing the loading state, without data or error state.
   *
   * @returns {Loadable<T>} A Loadable representing the loading state
   **/
  export function loading<T>(): Loadable<T> {
    return {
      data: undefined,
      isLoading: true,
      loadingError: undefined,
    };
  }

  /**
   * Create a Loadable representing the error state, without data or loading state.
   *
   * @param {any} loadingError - the error encountered whilst loading
   * @returns {Loadable<T>} A Loadable representing the error state
   **/
  export function errored<T>(loadingError: any): Loadable<T> {
    return {
      data: undefined,
      isLoading: undefined,
      loadingError,
    };
  }
}
